import { styled } from 'styled-components';

export const RadioCardChildrenContainer = styled.div`
  flex: 1 1 auto;
`;
